import React, { Component } from 'react';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import { actionCreators } from '../actions/globalAction';
import { getOptions } from '../components/options/durchschnitt';
import { data } from '../components/data/durchschnitt';
import { durchschnitt } from '../components/objects/durchschnitt';
import { StatCard, StatCardSkeleton } from '../components/solar/StatCard';
import { ChartCardWithPagination } from '../components/solar/ChartCardWithPagination';
import { Bar } from 'react-chartjs-2';
import { Card, Alert } from 'react-bootstrap';

class DurchschnittClass extends Component {

    static getDerivedStateFromProps(nextProps, prevState) {
        const nextYear = parseInt(nextProps.match.params.Year) || 0;
        if (prevState.prevYear !== nextYear) {
            return { prevYear: nextYear, _fetchNeeded: true };
        }
        return null;
    }

    state = {};

    componentDidMount() {
        const Year = parseInt(this.props.match.params.Year) || 0;

        this.setState({ prevYear: Year }, () => {
            if (Year > 0) {
                durchschnitt.DurchschnittimJahrClass.url = durchschnitt.DurchschnittimJahrClass.defaultSegment + "/imJahr/" + Year;
                durchschnitt.DurchschnittimJahrClass.forceRefresh = true;
            }
            else {
                durchschnitt.DurchschnittimJahrClass.url = durchschnitt.DurchschnittimJahrClass.defaultSegment + "/imJahr/" + new Date().getFullYear();
            }

            this.props.request(durchschnitt["DurchschnittimJahrClass"]);
        });
    }

    componentDidUpdate(prevProps) {
        // Handle year change from route params (set by getDerivedStateFromProps)
        if (this.state._fetchNeeded) {
            const nextYear = parseInt(this.props.match.params.Year) || 0;

            this.setState({ _fetchNeeded: false }, () => {
                if (nextYear > 0) {
                    durchschnitt.DurchschnittimJahrClass.forceRefresh = true;
                    durchschnitt.DurchschnittimJahrClass.url = durchschnitt.DurchschnittimJahrClass.defaultSegment + "/imJahr/" + nextYear;
                    this.props.request(durchschnitt["DurchschnittimJahrClass"]);
                }
            });
        }

        // When the update API responds, check success and trigger data refetch
        const updateResult = this.props.BarDiagrammUpdateDurchschnittUI;
        if (updateResult && !prevProps.BarDiagrammUpdateDurchschnittUI) {
            durchschnitt.DurchschnittimJahrClass.forceRefresh = true;
            const Year = parseInt(this.props.match.params.Year) || new Date().getFullYear();
            durchschnitt.DurchschnittimJahrClass.url = durchschnitt.DurchschnittimJahrClass.defaultSegment + "/imJahr/" + Year;
            this.props.request(durchschnitt["DurchschnittimJahrClass"]);
            this.props.reset(durchschnitt["DurchschnittimJahrUpdateResetClass"]);
            this.setState({ isUpdating: false, showMessage: true });

            // Auto-hide message after 5 seconds
            setTimeout(() => {
                this.setState({ showMessage: false });
            }, 5000);
        }
    }

    handleUpdateClick = () => {
        const Year = parseInt(this.props.match.params.Year) || new Date().getFullYear();
        durchschnitt.DurchschnittimJahrUpdateClass.url = durchschnitt.DurchschnittimJahrUpdateClass.defaultSegment + "?type=1&year=" + Year;
        durchschnitt.DurchschnittimJahrUpdateClass.forceRefresh = true;
        this.setState({ isUpdating: true, showMessage: false });
        this.props.request(durchschnitt["DurchschnittimJahrUpdateClass"]);
    };

    render() {
        return (
            <div>
                {renderKPIRow(this.props)}
                {renderUIGesamt(this, this.props)}
            </div>
        );
    }
}

/**
 * KPI-Zeile: Regionaler Soll, Mein Ist, Erreichungsquote, bester Monat
 */
function renderKPIRow(props) {
    const ui = props.BarDiagrammDurchschnittUI || {};

    // BOTH is Loaded=true UND Daten vorhanden
    let hasData = typeof (ui) !== 'undefined' && ui.length > 0;

    if (!props.isLoaded || !hasData) {
        return (
            <div className="stat-cards-row">
                <StatCardSkeleton />
                <StatCardSkeleton />
                <StatCardSkeleton variant="progress" />
                <StatCardSkeleton />
            </div>
        );
    }

    let rpvSoll = 0;
    let rpvist = 0;
    let filled = 0;
    let peakMonth = '-';
    let peakValue = 0;

    for (var k in ui) {
        if (ui[k].soll > 0 && ui[k].ist > 0) {
            rpvSoll += ui[k].soll;
            rpvist += ui[k].ist;
            filled++;
        }
        if (ui[k].ist > peakValue) {
            peakValue = ui[k].ist;
            peakMonth = ui[k].Monat || '-';
        }
    }

    const avgSoll = filled > 0 ? Math.round(((rpvSoll / filled) / 100) * 100) : 0;
    const avgIst = filled > 0 ? Math.round(((rpvist / filled) / 100) * 100) : 0;
    const quote = avgSoll > 0 ? Math.round((avgIst / avgSoll) * 100) : 0;

    // Konditionale Farbcodierung der Erreichungsquote
    let quoteVariant = 'danger';
    if (quote >= 100) quoteVariant = 'energy';
    else if (quote >= 75) quoteVariant = 'info';

    const diff = avgIst - avgSoll;
    const diffText = diff >= 0 ? '+' + diff : '' + diff;

    return (
        <div className="stat-cards-row">
            <StatCard
                value={avgSoll}
                label="Regionaler Durchschnitt"
                unit=" kWh/kWp"
                icon={<i className="bi bi-bar-chart" />}
                subLabel={'Benchmark ' + filled + ' Monate'}
                description="Durchschnittlicher spez. Ertrag aller PV-Anlagen in der Region pro kWp installierter Leistung. Benchmark-Wert."
            />
            <StatCard
                value={avgIst}
                label="Meine Anlage"
                unit=" kWh/kWp"
                icon={<i className="bi bi-sun" />}
                variant="energy"
                subLabel={'gegenüber: ' + diffText + ' kWh/kWp'}
                description="Dein spezifischer Ertrag in kWh pro kWp. Direkter Vergleich mit dem regionalen Durchschnitt möglich."
            />
            <StatCard
                value={quote}
                label="Quote zum Regionalwert"
                unit=" %"
                icon={<i className="bi bi-bullseye" />}
                variant={quoteVariant}
                subLabel={quote + '% vom Reg.'}
                description="Deine Anlage im Vergleich zum Regionaldurchschnitt. Über 100% bedeutet bessere Leistung als der Durchschnitt."
            />
            <StatCard
                value={Math.round(peakValue)}
                label={"Bester Monat: " + peakMonth}
                unit=" kWh/kWp"
                icon={<i className="bi bi-graph-up-arrow" />}
                subLabel={Math.round(peakValue) + ' in ' + peakMonth}
                description="Monat mit dem höchsten spezifischen Ertrag. Typischerweise zwischen Mai und August."
            />
        </div>
    );
}

function renderUIGesamt(componentRef, props) {
    let BarDiagrammDurchschnittUI = props.BarDiagrammDurchschnittUI || {};

    // BOTH check: Skelett so lange zeigen, BIS isLoaded=true UND Daten vorhanden!
    let hasData = typeof (BarDiagrammDurchschnittUI) !== 'undefined' && BarDiagrammDurchschnittUI.length > 0;
    let loading = !props.isLoaded || !hasData;

    let chartData = { labels: [''], datasets: [{ data: [0] }, { data: [0] }] };

    if (hasData) {
        let labels = [];
        let dataist = [];
        let datasoll = [];
        let istBgColors = [];
        let Vergleich = []; // for datalabels formatter: >= 100% or < 100%

        for (var k in BarDiagrammDurchschnittUI) {
            const sollVal = BarDiagrammDurchschnittUI[k].soll;
            const istVal = BarDiagrammDurchschnittUI[k].ist;

            labels.push(BarDiagrammDurchschnittUI[k].Monat);
            dataist.push(istVal);
            datasoll.push(sollVal);

            // Per-bar color based on Soll comparison
            if (sollVal > 0 && istVal >= sollVal) {
                istBgColors.push('rgba(34, 197, 94, 0.85)');   // Grün — erreicht ✓
                Vergleich.push(true);
            } else if (sollVal > 0 && istVal >= sollVal * 0.75) {
                istBgColors.push('rgba(34, 197, 94, 0.5)');    // Helles Grün — nahe dran △
                Vergleich.push(false);
            } else {
                istBgColors.push('rgba(251, 191, 36, 0.6)');   // Amber — deutlich darunter
                Vergleich.push(false);
            }
        }

        chartData = {
            labels: labels,
            Vergleich: Vergleich,
            datasets: [
                { ...data.datasets[0], data: datasoll },
                { ...data.datasets[1], data: dataist, backgroundColor: istBgColors }
            ]
        };
    }

    const isUpdating = componentRef.state.isUpdating || false;
    const showMessage = componentRef.state.showMessage !== false && props.UpdateMessage;
    const isSuccess = props.UpdateSuccess;

    let buttonClass = 'btn btn-outline-primary btn-update-diagramm';
    let iconClass = 'bi bi-arrow-clockwise';
    let label = 'Update Diagramm';

    if (isUpdating) {
        iconClass = 'bi bi-arrow-clockwise spinning-icon';
        label = 'Lade...';
        buttonClass = 'btn btn-primary btn-update-diagramm';
    }

    return (
        <div>
            <h3>Regionaler Durchschnitt kWh/kWp — Jahr {props.match?.params.Year || new Date().getFullYear()}</h3>
            <div className="chart-header-toolbar">
                {showMessage && (
                    <Alert variant={isSuccess ? 'success' : 'danger'} className="mb-0 alert-update-msg" role="alert">
                        <i className={`bi ${isSuccess ? 'bi-check-circle' : 'bi-exclamation-triangle'}`} />
                        {' '}{props.UpdateMessage}
                    </Alert>
                )}
                <button
                    type="button"
                    onClick={componentRef.handleUpdateClick}
                    className={buttonClass}
                    disabled={isUpdating}
                >
                    <i className={iconClass} /> {label}
                </button>
            </div>
            <ChartCardWithPagination
                routeSegment={'durchschnitt'}
                onlyYear={true}
                match={props.match}
                history={props.history}
                loading={loading}>
                <Card className="chart-card">
                    <Card.Body>
                        <Bar data={chartData} options={{ ...getOptions(), animation: false }} />
                    </Card.Body>
                </Card>
            </ChartCardWithPagination>
        </div>
    );
}

export default connect(
    state => state.durchschnittReducer,
    dispatch => bindActionCreators(actionCreators, dispatch)
)(DurchschnittClass);
